import React, { useState } from 'react';
import {
  Dialog, AppBar, Toolbar, IconButton, Typography, Slide, Box,
  Autocomplete, TextField, Card, Stack, Divider, Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import makatData from '../utils/makatData';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Options support searching by name OR by מק"ט
const options = makatData.map(item => ({
  label: item.name,
  makat: item.makat,
  sources: item.sources,
}));

export default function MakatSearch({ open, handleClose }) {
  const [inputValue, setInputValue] = useState('');
  const [selected, setSelected]     = useState(null);
  const [copied, setCopied]         = useState(false);

  const handleCopy = () => {
    if (!selected) return;
    navigator.clipboard.writeText(selected.makat).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleReset = () => {
    setInputValue('');
    setSelected(null);
    setCopied(false);
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
            חיפוש מק"ט
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 3, maxWidth: 500, mx: 'auto', mt: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          חפש לפי שם הפריט או מספר מק"ט
        </Typography>

        <Autocomplete
          options={options}
          inputValue={inputValue}
          getOptionLabel={opt => (typeof opt === 'string' ? opt : opt.label)}
          onInputChange={(_, val) => {
            setInputValue(val);
            if (!val) setSelected(null);
          }}
          onChange={(_, val) => setSelected(val || null)}
          filterOptions={(opts, { inputValue: iv }) => {
            if (iv.length < 2) return [];
            const q = iv.toLowerCase();
            return opts
              .filter(o => o.label.toLowerCase().includes(q) || o.makat.includes(q))
              .slice(0, 25);
          }}
          renderOption={(props, option) => (
            <li {...props} key={option.makat}>
              <Box sx={{ width: '100%' }}>
                <Typography variant="body2">{option.label}</Typography>
                <Typography variant="caption" color="text.secondary">
                  מק"ט: {option.makat}
                </Typography>
              </Box>
            </li>
          )}
          renderInput={params => (
            <TextField
              {...params}
              label='שם פריט / מק"ט'
              fullWidth
              autoFocus
            />
          )}
          noOptionsText={inputValue.length < 2 ? 'הקלד לפחות 2 תווים' : 'לא נמצאו תוצאות'}
        />

        {selected && (
          <Card
            sx={{
              mt: 3,
              p: 2.5,
              border: 2,
              borderColor: 'primary.main',
              borderRadius: 2,
            }}
          >
            <Stack spacing={1.5}>
              <Typography variant="h6" fontWeight="bold">
                {selected.label}
              </Typography>

              <Divider />

              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography color="text.secondary">מק"ט:</Typography>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography fontWeight="bold" fontSize="1.1rem" sx={{ letterSpacing: '0.05em' }}>
                    {selected.makat}
                  </Typography>
                  <Tooltip title={copied ? 'הועתק!' : 'העתק מק"ט'} arrow>
                    <IconButton
                      size="small"
                      onClick={handleCopy}
                      sx={{
                        color: copied ? 'success.main' : 'action.active',
                        transition: 'color 0.2s',
                      }}
                    >
                      {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
                    </IconButton>
                  </Tooltip>
                </Stack>
              </Stack>

            </Stack>
          </Card>
        )}

        {inputValue.length >= 2 && !selected && (
          <Card sx={{ mt: 3, p: 2, bgcolor: 'grey.100' }}>
            <Typography color="text.secondary" textAlign="center">
              פריט לא נמצא במאגר
            </Typography>
          </Card>
        )}
        <Box sx={{ mt: 5, pt: 2, borderTop: '1px solid', borderColor: 'divider' }}>
          <Typography variant="caption" color="text.disabled" sx={{ lineHeight: 1.7, display: 'block', textAlign: 'center' }}>
            המערכת נמצאת בשלב ראשוני ומכילה חלק מהפריטים.
            <br />
            בהמשך תתווספנה ערכות, טבלאות מלאות ותמונות של הפריטים.
          </Typography>
        </Box>
      </Box>
    </Dialog>
  );
}
